import z from 'zod';
export const userCalendarIdValue = z.string().trim().min(1)
    .brand('UserCalendarId');
export const createUserCalendarId = (value) => userCalendarIdValue.parse(value);
export const isUserCalendarId = (value) => userCalendarIdValue.safeParse(value).success;
/** Opaque ICS feed capability token (32-byte base64url). */
export const calendarFeedTokenValue = z
    .string()
    .regex(/^[\w-]{43}$/)
    .brand('CalendarFeedToken');
export const createCalendarFeedToken = (value) => calendarFeedTokenValue.parse(value);
export const isCalendarFeedToken = (value) => calendarFeedTokenValue.safeParse(value).success;
//# sourceMappingURL=ids.js.map